import { getId } from "helpers/functions";
import {
  GET_SUBCONTROL_DOMAINS,
  GET_SUBCONTROL_DOMAINS_FAILURE,
  GET_SUBCONTROL_DOMAINS_SUCCESS,
  ADD_SUBCONTROL_DOMAIN,
  ADD_SUBCONTROL_DOMAIN_SUCCESS,
  ADD_SUBCONTROL_DOMAIN_FAILURE,
  DELETE_SUBCONTROL_DOMAIN,
  DELETE_SUBCONTROL_DOMAIN_SUCCESS,
  DELETE_SUBCONTROL_DOMAIN_FAILURE,
  GET_SINGLE_SUBCONTROL_DOMAIN,
  GET_SINGLE_SUBCONTROL_DOMAIN_FAILURE,
  GET_SINGLE_SUBCONTROL_DOMAIN_SUCCESS,
  SET_DEFAULT_SUBCONTROL_DOMAIN_SUCCESS,
} from "./actionTypes";

const initialState = {
  subControlDomains: [],
  loading: false,
  error: "",
  singleSubControlDomain: {},
};

const stores = (state = initialState, action) => {
  switch (action.type) {
    case GET_SUBCONTROL_DOMAINS:
      state = {
        ...state,
        loading: true,
      };
      break;
    case GET_SUBCONTROL_DOMAINS_SUCCESS:
      state = {
        ...state,
        loading: false,
        subControlDomains: action.payload.subControlDomains,
      };
      break;
    case GET_SUBCONTROL_DOMAINS_FAILURE:
      state = { ...state, error: action.payload, loading: false };
      break;

    case GET_SINGLE_SUBCONTROL_DOMAIN:
      state = {
        ...state,
        loading: true,
      };
      break;
    case GET_SINGLE_SUBCONTROL_DOMAIN_SUCCESS:
      state = {
        ...state,
        loading: false,
        singleSubControlDomain: action.payload.subControlDomain,
      };
      break;
    case GET_SINGLE_SUBCONTROL_DOMAIN_FAILURE:
      state = { ...state, error: action.payload, loading: false };
      break;

    case ADD_SUBCONTROL_DOMAIN:
      state = {
        ...state,
        loading: true,
      };
      break;
    case ADD_SUBCONTROL_DOMAIN_SUCCESS:
      state = {
        ...state,
        loading: false,
        subControlDomains: action.payload.subControlDomains,
      };
      break;
    case ADD_SUBCONTROL_DOMAIN_FAILURE:
      state = { ...state, error: action.payload, loading: false };
      break;

    case DELETE_SUBCONTROL_DOMAIN:
      state = {
        ...state,
        loading: true,
      };
      break;
    case DELETE_SUBCONTROL_DOMAIN_SUCCESS:
      const usersAfterDeleteing = [
        ...state?.subControlDomains?.filter(
          (subControlDomain) => getId(subControlDomain) !== action.payload
        ),
      ];

      state = {
        ...state,
        loading: false,
        subControlDomains: usersAfterDeleteing,
      };
      break;
    case DELETE_SUBCONTROL_DOMAIN_FAILURE:
      state = {
        ...state,
        loading: false,
        error: action.payload,
      };
      break;

    case SET_DEFAULT_SUBCONTROL_DOMAIN_SUCCESS:
      const defaultItems = [
        ...(state?.subControlDomains || [])?.map((item) =>
          getId(item) === action.payload?.id
            ? { ...item, isDefault: true }
            : { ...item, isDefault: false }
        ),
      ];

      state = {
        ...state,
        subControlDomains: defaultItems,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default stores;
